import { render, staticRenderFns } from "./SocietyMatchWizardsStepFour.vue?vue&type=template&id=614580ae&scoped=true"
import script from "./SocietyMatchWizardsStepFour.vue?vue&type=script&lang=js"
export * from "./SocietyMatchWizardsStepFour.vue?vue&type=script&lang=js"
import style0 from "./SocietyMatchWizardsStepFour.vue?vue&type=style&index=0&id=614580ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614580ae",
  null
  
)

export default component.exports